/* EnzyPaw PDP: vanilla port of the React interactions (gallery, kits, box panel, cart, accordions, slider). */
(function () {
  var root = document.querySelector(".enzypaw-site");
  if (!root) return;

  // CSS-module class names: "<module>-module__<hash>__<name>". Find each module's prefix once.
  var prefixes = {};
  root.querySelectorAll("[class]").forEach(function (el) {
    el.classList.forEach(function (c) {
      var m = c.match(/^([a-z-]+)-module__[A-Za-z0-9_-]+?__/);
      if (m && !prefixes[m[1]]) prefixes[m[1]] = m[0];
    });
  });
  function cls(mod, name) {
    return (prefixes[mod] || "") + name;
  }
  function q(sel, ctx) {
    return (ctx || root).querySelector(sel);
  }
  function qa(sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  }
  function byName(mod, name, ctx) {
    return q("." + cls(mod, name), ctx);
  }
  function allByName(mod, name, ctx) {
    return qa("." + cls(mod, name), ctx);
  }

  // ---------- product ----------
  var product = null;
  try {
    product = JSON.parse(document.getElementById("ep-product").textContent);
  } catch (e) {}
  function variant() {
    return product && product.variants && product.variants[0] ? product.variants[0] : null;
  }
  var stickyBtn = byName("chrome", "stickyButton", document);

  // ---------- add to cart ----------
  function addToCart(btn) {
    var v = variant();
    if (!v) {
      alert("This product isn't set up in the store yet.");
      return;
    }
    if (btn) btn.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart";
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        alert("Couldn't add to cart. Please try again.");
      });
  }
  // Lander: CTAs are plain links to the PDP, so skip cart and scroll handlers.
  var isLander = root.hasAttribute("data-ep-lander");
  var form = document.getElementById("enzypaw-product-form");
  if (!isLander) {
    var atc = byName("main-product", "atc");
    if (atc) atc.addEventListener("click", function () { addToCart(atc); });
    if (stickyBtn) stickyBtn.addEventListener("click", function () { addToCart(stickyBtn); });

    // ---------- scroll-to-form CTAs ----------
    var toForm = function () {
      if (form) form.scrollIntoView({ behavior: "smooth", block: "center" });
    };
    qa('a[href="#enzypaw-product-form"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        toForm();
      });
    });
    var savingsCta = byName("savings", "cta");
    if (savingsCta) savingsCta.addEventListener("click", function () { toForm(); });
  }

  // ---------- sticky ATC ----------
  var sticky = byName("chrome", "sticky", document);
  if (sticky && form && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle(cls("chrome", "stickyHidden"), !(!e.isIntersecting && e.boundingClientRect.top < 0));
    }).observe(form);
  }

  // ---------- gallery ----------
  var track = byName("main-product", "track");
  if (track) {
    var slides = allByName("main-product", "slide", track);
    var thumbs = allByName("main-product", "thumb");
    var dots = allByName("main-product", "dot");
    var idx = 0;
    var go = function (i) {
      idx = ((i % slides.length) + slides.length) % slides.length;
      track.style.setProperty("--i", idx);
      slides.forEach(function (s, j) { s.setAttribute("aria-hidden", j === idx ? "false" : "true"); });
      thumbs.forEach(function (t, j) { t.classList.toggle(cls("main-product", "thumbActive"), j === idx); });
      dots.forEach(function (d, j) {
        d.classList.toggle(cls("main-product", "dotActive"), j === idx);
        d.setAttribute("aria-current", j === idx ? "true" : "false");
      });
    };
    thumbs.forEach(function (t, j) { t.addEventListener("click", function () { go(j); }); });
    dots.forEach(function (d, j) { d.addEventListener("click", function () { go(j); }); });
    var prev = q('[aria-label="Slide left"]');
    var next = q('[aria-label="Slide right"]');
    if (prev) prev.addEventListener("click", function () { go(idx - 1); });
    if (next) next.addEventListener("click", function () { go(idx + 1); });
    var viewer = byName("main-product", "viewer");
    var startX = null;
    if (viewer) {
      viewer.addEventListener("pointerdown", function (e) { startX = e.clientX; });
      viewer.addEventListener("pointerup", function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX;
        startX = null;
        if (dx > 40) go(idx - 1);
        else if (dx < -40) go(idx + 1);
      });
    }
  }

  // ---------- buy-box accordions ----------
  allByName("main-product", "faqItem").forEach(function (item) {
    var btn = byName("main-product", "faqButton", item);
    var panel = byName("main-product", "faqPanel", item);
    var icon = byName("main-product", "faqIcon", item);
    if (!btn || !panel) return;
    btn.addEventListener("click", function () {
      var open = !panel.classList.contains(cls("main-product", "faqPanelOpen"));
      panel.classList.toggle(cls("main-product", "faqPanelOpen"), open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      if (icon) icon.textContent = open ? "−" : "+";
    });
  });

  // ---------- FAQ section ----------
  allByName("faq", "row").forEach(function (row) {
    var btn = byName("faq", "button", row);
    var panel = byName("faq", "panel", row);
    if (!btn || !panel) return;
    btn.addEventListener("click", function () {
      var open = !btn.classList.contains(cls("faq", "active"));
      btn.classList.toggle(cls("faq", "active"), open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      panel.style.maxHeight = open ? panel.scrollHeight + 25 + "px" : "";
    });
  });

  // ---------- before/after slider ----------
  var range = byName("image-compare", "control");
  if (range) {
    var before = byName("image-compare", "before");
    var after = byName("image-compare", "after");
    var divider = byName("image-compare", "divider");
    var compare = byName("image-compare", "compare");
    var update = function () {
      var v = Number(range.value);
      if (before) before.style.clipPath = "inset(0 " + (100 - v) + "% 0 0)";
      if (after) after.style.clipPath = "inset(0 0 0 " + v + "%)";
      if (divider) divider.style.left = v + "%";
      var lb = byName("image-compare", "labelBefore", compare);
      var la = byName("image-compare", "labelAfter", compare);
      if (lb) lb.style.visibility = v > 15 ? "" : "hidden";
      if (la) {
        la.style.visibility = v < 85 ? "" : "hidden";
        la.style.left = "calc(" + v + "% + 2px)";
      }
    };
    range.addEventListener("input", update);
  }

  // ---------- buy-box review slider ----------
  var rTrack = byName("main-product", "reviewTrack");
  if (rTrack) {
    var rBullets = allByName("main-product", "bullet");
    var rSlides = allByName("main-product", "reviewSlide", rTrack);
    var rIdx = 0;
    var rGo = function (i) {
      rIdx = Math.max(0, Math.min(rSlides.length - 1, i));
      rTrack.style.transform = "translateX(calc(" + -rIdx + " * (100% + 10px)))";
      rBullets.forEach(function (b, j) { b.classList.toggle(cls("main-product", "bulletActive"), j === rIdx); });
    };
    rBullets.forEach(function (b, j) { b.addEventListener("click", function () { rGo(j); }); });
    var rView = byName("main-product", "reviewViewport");
    var rStart = null;
    if (rView) {
      rView.addEventListener("pointerdown", function (e) { rStart = e.clientX; });
      rView.addEventListener("pointerup", function (e) {
        if (rStart === null) return;
        var dx = e.clientX - rStart;
        rStart = null;
        if (dx > 40) rGo(rIdx - 1);
        else if (dx < -40) rGo(rIdx + 1);
      });
    }
  }

  // ---------- testimonials carousel (looping) ----------
  var tTrack = byName("testimonials", "track");
  if (tTrack) {
    var COUNT = 4, MIN_POS = -12;
    var tSlides = allByName("testimonials", "slide", tTrack);
    var fill = byName("testimonials", "progressFill");
    var pos = 0, shifted = false;
    var mod = function (n, m) { return ((n % m) + m) % m; };
    var render = function () {
      tTrack.style.setProperty("--n", pos - MIN_POS);
      tTrack.style.setProperty("--shift-on", shifted ? 1 : 0);
      var first = shifted ? pos - 1 : pos, last = first + COUNT - 1;
      tSlides.forEach(function (el, k) {
        var p = MIN_POS + k, hide = p < first || p > last;
        el.style.visibility = hide ? "hidden" : "";
        if (hide) el.setAttribute("aria-hidden", "true"); else el.removeAttribute("aria-hidden");
      });
      if (fill) fill.style.transform = "scaleX(" + (mod(pos, COUNT) + 1) / COUNT + ")";
    };
    var tGo = function (dir) {
      tTrack.style.transitionDuration = "";
      pos += dir;
      shifted = dir === 1;
      render();
    };
    tTrack.addEventListener("transitionend", function (e) {
      if (e.target !== tTrack || Math.abs(pos) <= COUNT) return;
      tTrack.style.transitionDuration = "0ms";
      pos = mod(pos, COUNT);
      render();
      requestAnimationFrame(function () { requestAnimationFrame(function () { tTrack.style.transitionDuration = ""; }); });
    });
    var tPrev = q('[aria-label="Previous slide"]'), tNext = q('[aria-label="Next slide"]');
    if (tPrev) tPrev.addEventListener("click", function () { tGo(-1); });
    if (tNext) tNext.addEventListener("click", function () { tGo(1); });
    var tStart = null;
    tTrack.addEventListener("pointerdown", function (e) { tStart = e.clientX; });
    tTrack.addEventListener("pointerup", function (e) {
      if (tStart === null) return;
      var dx = e.clientX - tStart;
      tStart = null;
      if (dx <= -40) tGo(1);
      else if (dx >= 40) tGo(-1);
    });
  }

  // ---------- reviews wall: JSON-driven with Load More ----------
  var BATCH = 6;
  var TOTAL_DISPLAY = 1847;
  var reviewsData = [];
  try {
    reviewsData = JSON.parse(document.getElementById("enzypaw-reviews-data").textContent);
  } catch (e) {}
  var assets = window.__reviewAssets || {};
  var shown = 0;
  var columns = allByName("reviews-wall", "column");
  var loadBtn = document.getElementById("ep-reviews-load-btn");
  var countEl = document.getElementById("ep-reviews-count");
  var loadWrap = document.getElementById("ep-reviews-load-more");

  var starPath = "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z";
  var verifiedSvg = '<svg class="' + cls("reviews-wall", "verifiedIcon") + '" viewBox="0 0 14 14" width="14" height="14" aria-label="Verified buyer"><path d="M6.99999 12.8332C10.2217 12.8332 12.8333 10.2215 12.8333 6.99984C12.8333 3.77818 10.2217 1.1665 6.99999 1.1665C3.77833 1.1665 1.16666 3.77818 1.16666 6.99984C1.16666 10.2215 3.77833 12.8332 6.99999 12.8332Z" fill="#3E1B72" stroke="#3E1B72" stroke-width="0.5"></path><path d="M5.25 7.00016L6.41667 8.16683L8.75 5.8335" stroke="#fff" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function starsSvg(rating) {
    var html = "";
    for (var s = 0; s < 5; s++) {
      html += '<svg viewBox="0 0 24 24" aria-hidden="true"' + (s >= rating ? ' class="' + cls("reviews-wall", "starEmpty") + '"' : "") + '><path d="' + starPath + '"></path></svg>';
    }
    return html;
  }

  // Hidden columns (display:none at smaller widths) report height 0, so skip them.
  function visibleCols() {
    var v = columns.filter(function (col) { return col.offsetParent !== null; });
    return v.length ? v : columns.slice(0, 1);
  }
  function shortestCol() {
    var cols = visibleCols(), best = cols[0];
    cols.forEach(function (col) {
      if (col.offsetHeight < best.offsetHeight) best = col;
    });
    return best;
  }
  var renderedCards = [];
  var lastColCount = 0;
  function reflow() {
    var n = visibleCols().length;
    if (n === lastColCount) return;
    lastColCount = n;
    renderedCards.forEach(function (card) { card.remove(); });
    renderedCards.forEach(function (card) { shortestCol().appendChild(card); });
  }

  function renderCard(r) {
    var card = document.createElement("div");
    card.className = cls("reviews-wall", "card");
    var photoHtml = "";
    if (r.photo && assets[r.photo]) {
      photoHtml = '<img class="' + cls("reviews-wall", "cardPhoto") + '" src="' + assets[r.photo] + '" alt="" loading="lazy"/>';
    }
    card.innerHTML = photoHtml +
      '<div class="' + cls("reviews-wall", "cardBody") + '">' +
        '<div class="' + cls("reviews-wall", "cardAuthorRow") + '">' +
          '<span class="' + cls("reviews-wall", "cardName") + '">' + r.name + '</span>' +
          '<span class="' + cls("reviews-wall", "verified") + '">' + verifiedSvg + '</span>' +
        '</div>' +
        '<div class="' + cls("reviews-wall", "cardStars") + '">' + starsSvg(r.rating) + '</div>' +
        '<div class="' + cls("reviews-wall", "text") + '">' + r.text + '</div>' +
        '<div class="' + cls("reviews-wall", "footer") + '">' +
          '<button type="button" class="' + cls("reviews-wall", "like") + '">' +
            '<span class="' + cls("reviews-wall", "likeEmoji") + '">👍</span>' +
            '<span>Helpful</span>' +
            '<span class="' + cls("reviews-wall", "likeCount") + '">' + r.helpful + '</span>' +
          '</button>' +
        '</div>' +
      '</div>';
    var likeBtn = card.querySelector("." + cls("reviews-wall", "like"));
    if (likeBtn) {
      likeBtn.addEventListener("click", function () {
        if (likeBtn.classList.contains(cls("reviews-wall", "liked"))) return;
        likeBtn.classList.add(cls("reviews-wall", "liked"));
        var ct = likeBtn.querySelector("." + cls("reviews-wall", "likeCount"));
        if (ct) ct.textContent = String(Number(ct.textContent) + 1);
      });
    }
    return card;
  }

  function loadBatch() {
    var end = Math.min(shown + BATCH, reviewsData.length);
    for (var i = shown; i < end; i++) {
      var card = renderCard(reviewsData[i]);
      renderedCards.push(card);
      shortestCol().appendChild(card);
    }
    shown = end;
    if (countEl) countEl.textContent = "Showing " + shown + " of " + TOTAL_DISPLAY.toLocaleString() + " reviews";
    if (shown >= reviewsData.length && loadBtn) {
      loadBtn.style.display = "none";
    }
  }

  if (columns.length && reviewsData.length) {
    lastColCount = visibleCols().length;
    loadBatch();
    window.addEventListener("resize", reflow);
    if (loadBtn) {
      loadBtn.addEventListener("click", function () { loadBatch(); });
    }
  }
})();
